/*GET ALL ADMIN */
export const GET_ALL_ADMIN = "GET_ALL_ADMIN"
export const GET_ALL_ADMIN_SUCCESS = "GET_ALL_ADMIN_SUCCESS"
export const GET_ALL_ADMIN_FAIL = "GET_ALL_ADMIN_FAIL"

// GET ADMIN ROLES
export const GET_ADMIN_ROLES = "GET_ADMIN_ROLES"
export const GET_ADMIN_ROLES_SUCCESS = "GET_ADMIN_ROLES_SUCCESS"
export const GET_ADMIN_ROLES_FAIL = "GET_ADMIN_ROLES_FAIL"